// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__22h71","ranges":"BmiRanges_ranges__1alx3"};